module.exports = __webpack_public_path__ + "img/seaPalace-1.68df7301.jpg";